import { defineAsyncComponent } from 'vue'
export default {
  anonymous: defineAsyncComponent(() => import("/home/circleci/sleuth/frontend/layouts/anonymous.vue").then(m => m.default || m)),
  artifact: defineAsyncComponent(() => import("/home/circleci/sleuth/frontend/layouts/artifact.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/circleci/sleuth/frontend/layouts/default.vue").then(m => m.default || m)),
  issues: defineAsyncComponent(() => import("/home/circleci/sleuth/frontend/layouts/issues.vue").then(m => m.default || m)),
  modal: defineAsyncComponent(() => import("/home/circleci/sleuth/frontend/layouts/modal.vue").then(m => m.default || m))
}